import { ArithmeticOperation, JtfMode } from '@suntex.fim/enums';

export function getCellLabel(
  rowIdx: number,
  colIdx: number,
  operation: ArithmeticOperation,
  mode: JtfMode,
  leftProblems: string[][],
  rightProblems: string[][],
  operatorSymbol: string,
): string {
  let rightIdx = colIdx;

  // Handle special cases for multiplication
  if (
    operation === ArithmeticOperation.Multiplication &&
    mode !== JtfMode.Fractions
  ) {
    if (rowIdx === 0 && colIdx === 0) return '';
    if (rowIdx === 0 && colIdx !== 0) {
      rightIdx = colIdx - 1;
    }
  }

  // Handle special cases for division
  if (
    operation === ArithmeticOperation.Division &&
    (mode === JtfMode.WholeNumbers || mode === JtfMode.Integers)
  ) {
    if (colIdx === 0) return '';
    rightIdx = colIdx - 1;
  }

  const left = leftProblems[rowIdx]?.[rightIdx] ?? '';
  const right = rightProblems[rowIdx]?.[rightIdx] ?? '';
  return left && right ? `${left} ${operatorSymbol} ${right}` : '';
}
